export default "__VITE_ASSET__6474a61d__"